export default "{\n// this is a test\n    \"key\": \"value\"\n}"